import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-cinema-bg">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-white mb-3">焦点专题</h2>
          <p className="text-sm text-cinema-muted">精选内容专题 · 一站式深度观影指南</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {carouselItems.map((item, i) => (
            <a
              key={i}
              href="#index"
              className="group relative bg-cinema-card hover:bg-cinema-card-hover border border-cinema-border hover:border-cinema-gold/20 rounded-xl overflow-hidden transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[2/1] overflow-hidden">
                <img
                  src={item.coverUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-cinema-bg via-cinema-bg/50 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <p className="text-xs text-cinema-gold mb-1 font-medium">{item.subtitle}</p>
                <h3 className="text-lg md:text-xl font-heading text-white mb-2">{item.title}</h3>
                <p className="text-xs md:text-sm text-cinema-text-dim leading-relaxed line-clamp-2 mb-3">{item.desc}</p>
                <span className="inline-flex items-center gap-1 text-xs text-cinema-gold font-medium group-hover:gap-2 transition-all">
                  {item.cta}
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}